export default __webpack_public_path__ + "static/media/kocek_white.108160f4.svg";